import React, { useRef, Suspense, lazy } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../global.css";
import { getImageUrl } from "../../utils/imageHelper";

const VideoPlayer = lazy(() => import("../common/VideoPlayer"));

export default function LatestVideo({ homeData }) {
  const sliderRef = useRef(null);
  
  const videoItems = (homeData?.testimonial || []).filter(
    (item) => item?.formType === "Testimonial"
  );

  const displayList = videoItems.length > 0
    ? videoItems
    : [{ formType: "Testimonial", image_video: "https://youtu.be/SuB7TWpMaAI", title: "Vivashri Success Story" }];

  const videoCount = displayList.length;

  const settings = {
    infinite: videoCount > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    speed: 550,
    dots: false,
    arrows: false,
  };

  if (videoCount === 1) {
    const item = displayList[0];
    const videoUrl = item.image_video?.startsWith("http")
      ? item.image_video
      : getImageUrl(item.image_video);

    const posterImage = item.poster || item.thumbnail || item.image;
    const posterUrl = posterImage ? getImageUrl(posterImage) : "";

    return (
      <div className="single-video-container" style={{ width: "100%", maxWidth: "540px", margin: "0 auto", padding: "0 6px" }}>
        <Suspense fallback={<div style={{ paddingTop: "56.25%", background: "#0f0c20", borderRadius: "18px" }} />}>
          <VideoPlayer
            src={videoUrl}
            poster={posterUrl}
            title={item.title}
            type="video/mp4"
          />
        </Suspense>
      </div>
    );
  }

  return (
    <>
      <Slider ref={sliderRef} {...settings}>
        {displayList.map((item, index) => {
          const videoUrl = item.image_video?.startsWith("http")
            ? item.image_video
            : getImageUrl(item.image_video);

          const posterImage = item.poster || item.thumbnail || item.image;
          const posterUrl = posterImage ? getImageUrl(posterImage) : "";

          return (
            <div className="item" key={index} style={{ padding: "0 6px" }}>
              <Suspense fallback={<div style={{ paddingTop: "56.25%", background: "#0f0c20", borderRadius: "18px" }} />}>
                <VideoPlayer
                  src={videoUrl}
                  poster={posterUrl}
                  title={item.title}
                  type="video/mp4"
                />
              </Suspense>
            </div>
          );
        })}
      </Slider>

      <div className="owl-nav-latest">
        <button onClick={() => sliderRef.current?.slickPrev()} type="button" role="presentation" className="owl-prev"><i className="fa-solid fa-angle-left"></i></button>
        <button onClick={() => sliderRef.current?.slickNext()} type="button" role="presentation" className="owl-next"><i className="fa-solid fa-angle-right"></i></button>
      </div>
    </>
  );
}
